<template>
  <div class="bg-cover" :style="bgImg" id="home">
    <div class="container-fluid container-fluid--cp-150">
      <div class="row pb-5">
        <div class="col-lg-12">
          <div class="payment-hero-hero__content section-space--mt_30">
            <header-proximo
              v-if="getCursoProximoWebinar.length > 0"
              :datos="getCursoProximoWebinar"
            />
            <header-hoy
              v-else-if="getHoyWebinar.length > 0"
              :datos="getHoyWebinar"
            />
            <headerNormal v-else />
          </div>
        </div>
      </div>
    </div>
    <CurveShape>
      <template v-slot:bgcolor>
        <path
          style="fill: #ffff; stroke-miterlimit: 10"
          d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"
        />
      </template>
    </CurveShape>
  </div>
</template>

<script>
import CurveShape from "@/components/CurveShape";
import headerNormal from "@/components/features/encabezado/haederNormalComponent";
import headerProximo from "@/components/features/encabezado/headerProximoComponent";
import headerHoy from "@/components/features/encabezado/headerHoyComponent";
import gql from "graphql-tag";
import moment from "moment";
export default {
  props: {},
  data() {
    return {
      bgImg: {
        backgroundImage: `linear-gradient(180deg,#ff7e2e 0%,#ff5601 100%)`,
        getCursoProximoWebinar: [],
        getHoyWebinar: [],
      },
    };
  },
  components: {
    CurveShape,
    headerNormal,
    headerHoy,
    headerProximo,
  },
  created(){
    this.$apollo.queries.getCursoProximoWebinar.refetch()
    this.$apollo.queries.getHoyWebinar.refetch()
  },
  apollo: {
    getCursoProximoWebinar: {
      query: gql`
        query ($fecha: String) {
          getCursoProximoWebinar(fecha: $fecha) {
            _id
            img
            nombre
            descripcion
            precio
            fecha_curso
            formato_curso
            tipo_curso
            categoria {
              _id
              nombre
            }
          }
        }
      `,
      pollInterval: 120000,
      variables() {
        return {
          fecha: moment().format("YYYY-MM-DD HH:mm"),
        };
      },
    },
    getHoyWebinar: {
      query: gql`
        query ($fecha: String) {
          getHoyWebinar(fecha: $fecha) {
            _id
            img
            nombre
            descripcion
            precio
            fecha_curso
            formato_curso
            tipo_curso
            categoria {
              _id
              nombre
            }
          }
        }
      `,
      pollInterval: 120000,
      variables() {
        return {
          fecha: moment().format("YYYY-MM-DD"),
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.circulos-forum {
  position: absolute;
  border-radius: 50%;
  animation: jump infinite 2s;
  animation-direction: alternate;
  background-color: #f76b1c;
  background-image: radial-gradient(
    79.16% 79.16% at 55.39% 17.41%,
    #fff1be 0%,
    #ffcc0d 69.19%,
    #ffaa01 100%
  );
  &.one {
    width: 142px;
    height: 142px;
    left: 20%;
    top: 18px;
  }

  &.two {
    width: 72.12px;
    height: 72.12px;
    left: 62%;
    bottom: 25px;
    margin-top: -8px;
    animation-delay: 1s;
  }
  &.tree {
    width: 36.52px;
    height: 36.52px;
    left: 74%;
    bottom: 105px;
    margin-top: -8px;
    animation-delay: 2s;
  }

  &--blue {
    background-color: #9c7af2;
    background-image: linear-gradient(-224deg, #9c7af2 0, #5e61e7 100%);
  }

  &--bg-blue {
    background: #5945e6;
    box-shadow: 0 2px 17px rgba(89, 69, 230, 0.27);
  }
  &--bg-green {
    background: #38cb89;
    box-shadow: 0 2px 17px rgba(89, 69, 230, 0.27);
  }
}

@keyframes jump {
  0% {
    transform: translateY(-10px) scale(0.9, 0.9);
  }
  100% {
    transform: translateY(10px) scale(1, 1);
  }
}
</style>